export const demoDashboard = {
  stats: {
    revenue: 128750,
    monthlyProfit: 41200,
    productsAnalyzed: 1845,
    aiPerformance: 97,
  },
  chartData: [
    { name: 'Mon', revenue: 18250, profit: 6150 },
    { name: 'Tue', revenue: 19400, profit: 6525 },
    { name: 'Wed', revenue: 20580, profit: 6840 },
    { name: 'Thu', revenue: 21440, profit: 7120 },
    { name: 'Fri', revenue: 22890, profit: 7560 },
    { name: 'Sat', revenue: 24210, profit: 8080 },
    { name: 'Sun', revenue: 23800, profit: 7920 },
  ],
  topProducts: [
    {
      title: 'LEGO Millennium Falcon Collector Set',
      marketplace: 'Amazon US',
      price: '199.99',
      image_url: 'https://images.unsplash.com/photo-1589118949245-7d38baf380d6?auto=format&fit=crop&w=200&q=80',
    },
    {
      title: 'iRobot Roomba j7 Robot Vacuum',
      marketplace: 'Best Buy',
      price: '599.00',
      image_url: 'https://images.unsplash.com/photo-1581578017428-5c07bd5a19a7?auto=format&fit=crop&w=200&q=80',
    },
    {
      title: 'Stanley Adventure Quencher 40oz',
      marketplace: 'Target',
      price: '49.99',
      image_url: 'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?auto=format&fit=crop&w=200&q=80',
    },
    {
      title: 'Sony WH-1000XM5 Wireless Headphones',
      marketplace: 'Amazon CA',
      price: '348.00',
      image_url: 'https://images.unsplash.com/photo-1585386959984-a4155224a1ad?auto=format&fit=crop&w=200&q=80',
    },
    {
      title: 'LEVOIT Core 300S Smart Air Purifier',
      marketplace: 'Walmart',
      price: '189.99',
      image_url: 'https://images.unsplash.com/photo-1546868871-7041f2a55e12?auto=format&fit=crop&w=200&q=80',
    },
  ],
  products: [
    {
      title: 'Zojirushi Stainless Steel Mug 20oz',
      marketplace: 'Amazon US',
      price: '32.99',
      image_url: 'https://images.unsplash.com/photo-1524594154908-edd315c10831?auto=format&fit=crop&w=200&q=80',
    },
    {
      title: 'Bissell Little Green ProHeat',
      marketplace: 'Target',
      price: '179.99',
      image_url: 'https://images.unsplash.com/photo-1600585154340-0ef3c08e0cf0?auto=format&fit=crop&w=200&q=80',
    },
    {
      title: 'Ninja Creami Deluxe Ice Cream Maker',
      marketplace: 'Costco',
      price: '249.99',
      image_url: 'https://images.unsplash.com/photo-1546554137-f86b9593a222?auto=format&fit=crop&w=200&q=80',
    },
    {
      title: 'Fisher-Price Little People Launch & Loop',
      marketplace: 'Walmart',
      price: '49.97',
      image_url: 'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?auto=format&fit=crop&w=200&q=80',
    },
    {
      title: 'KitchenAid Artisan Stand Mixer',
      marketplace: 'Amazon EU',
      price: '429.99',
      image_url: 'https://images.unsplash.com/photo-1589308078055-50bb9482ed6d?auto=format&fit=crop&w=200&q=80',
    },
    {
      title: 'Lululemon Align High-Rise Pants',
      marketplace: 'Lululemon',
      price: '118.00',
      image_url: 'https://images.unsplash.com/photo-1523380996063-6b0d6d57d3b9?auto=format&fit=crop&w=200&q=80',
    },
  ],
  user: {
    name: 'Demo Seller',
    plan: 'pro',
    usage: {
      scans: 480,
      api_calls: 18200,
    },
    trial_days_left: 14,
  },
};

export default demoDashboard;
